import { C, FONT, hexA } from "../theme";
import { NAV } from "./meta";
import type { ViewKey, ControllerInfo } from "../types";

function BrandMark() {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      style={{ display: "block", flexShrink: 0 }}
      aria-hidden="true"
    >
      {/* ring */}
      <circle cx={20} cy={20} r={18.5} fill={C.paper} stroke={C.hairline} strokeWidth={1} />
      {/* marram-grass blade curves */}
      <path
        d="M20 31 C16 25 13.5 19 14 11"
        stroke={C.sage}
        strokeWidth={1.7}
        strokeLinecap="round"
      />
      <path
        d="M20 31 C20 24 20 17 20.5 9.5"
        stroke={C.sea}
        strokeWidth={1.7}
        strokeLinecap="round"
      />
      <path
        d="M20 31 C24 25 26.5 19.5 26 12"
        stroke={C.sage}
        strokeWidth={1.7}
        strokeLinecap="round"
      />
      {/* amber seed dot at the base */}
      <circle cx={20} cy={31} r={2.1} fill={C.beacon} />
    </svg>
  );
}

export function Sidebar({
  view,
  onNav,
  controller,
}: {
  view: ViewKey;
  onNav: (v: ViewKey) => void;
  controller: ControllerInfo;
}) {
  return (
    <aside
      style={{
        width: 264,
        flexShrink: 0,
        borderRight: `1px solid ${C.hairline}`,
        background: `linear-gradient(180deg, ${hexA(C.paper, 0.55)}, ${hexA(C.paper, 0)})`,
        padding: 18,
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      {/* Brand */}
      <div style={{ display: "flex", alignItems: "center", gap: 11, padding: "0 1px" }}>
        <BrandMark />
        <div style={{ minWidth: 0 }}>
          <div className="serif" style={{ fontSize: 21, fontWeight: 500, color: C.ink, lineHeight: 1.1 }}>
            Marram
          </div>
          <div style={{ fontSize: 11.5, color: C.mutedDeep }}>Falsterbo · 7 zones</div>
        </div>
      </div>

      {/* Nav */}
      <nav style={{ display: "flex", flexDirection: "column", gap: 4, marginTop: 26 }}>
        {NAV.map((n) => {
          const active = view === n.key;
          return (
            <button
              key={n.key}
              type="button"
              onClick={() => onNav(n.key)}
              aria-current={active ? "page" : undefined}
              style={{
                position: "relative",
                textAlign: "left",
                borderRadius: 11,
                padding: "11px 13px",
                fontSize: 13.5,
                fontFamily: FONT.sans,
                fontWeight: active ? 600 : 500,
                color: active ? C.ink : C.textMid,
                background: active ? hexA(C.sea, 0.1) : "transparent",
              }}
            >
              {active && (
                <span
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 8,
                    bottom: 8,
                    width: 3,
                    borderRadius: 99,
                    background: C.sea,
                  }}
                />
              )}
              {n.label}
            </button>
          );
        })}
      </nav>

      {/* Controller status card */}
      <div
        style={{
          marginTop: "auto",
          background: C.paper,
          border: `1px solid ${C.line}`,
          borderRadius: "var(--radius-card)",
          padding: 14,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span
            className="beacon-pulse"
            style={{ width: 8, height: 8, borderRadius: 99, background: C.sage, flexShrink: 0 }}
          />
          <span style={{ fontSize: 13, fontWeight: 600, color: C.ink }}>Online</span>
        </div>
        <div className="mono" style={{ marginTop: 8, fontSize: 11.5, color: C.textMid, lineHeight: 1.5 }}>
          {controller.network}
        </div>
        <div className="mono" style={{ marginTop: 2, fontSize: 11.5, color: C.textMid, lineHeight: 1.5 }}>
          {controller.board}
        </div>
      </div>
    </aside>
  );
}
